import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch } from "react-router-dom";

import { DayFilterContextProvider } from './DayFilterContext';
import { defaultStore } from './Contexts';
import Consents from './Consents';
import ErrorBoundary from './ErrorBoundary';
import Footer from './homepage/Footer';
import Header from './homepage/Header';
import Homepage from './homepage/Homepage';
import ReportSample from './homepage/ReportSample';
import { checkLoginStatus } from './actions/authentication';
import fetch, { defaultRequestConfig, handleError, getJson } from './actions/fetch';
import { reports } from './utils/config';
import './homepage/Homepage.css';

export const demoDays = '2019-04-22_2019-05-05';

const reportUrls = reports.map(u => `/reports/${u.id}/:${u.scope}`);

function LandingPageRoute({ standalone = false }) {
  const [signedInUser, setSignedInUser] = useState(undefined);
  const [mockStore, setMockStore] = useState(defaultStore);
  const reduxDispatch = useDispatch();

  const { t } = useTranslation('homepage');

  useEffect(() => {
    reduxDispatch(checkLoginStatus())
      .then((loginAction) => {
        const { payload = {} } = loginAction;
        const { user } = payload;
        setSignedInUser(user);
      });
  }, [reduxDispatch]);

  useEffect(() => {
    if (mockStore === defaultStore) {
      fetch(`${process.env.PUBLIC_URL}/store.json`, defaultRequestConfig)
        .then(handleError)
        .then(getJson)
        .then(setMockStore)
        .catch(console.error);
    }
  }, [mockStore, setMockStore]);

  return (
    <ErrorBoundary>
      {standalone
        ? undefined
        : <Header user={signedInUser} />
      }
      <Switch>
        <Route path={[...reportUrls, '/consentsDev']} children={({ history, match }) => (
          <DayFilterContextProvider history={history} match={match}>
            <Switch>
              <Route path="/consentsDev" component={Consents} />
              <Route path={reportUrls}>
                <ReportSample history={history} store={mockStore} />
              </Route>
            </Switch>
          </DayFilterContextProvider>
        )} />
        <Route path={['/reports/agp', '/reports/agp/']} exact>
          <Redirect to={`/reports/agp/${demoDays}`} />
        </Route>
        <Route path={['/reports/insulin', '/reports/insulin/']} exact>
          <Redirect to={`/reports/insulin/${demoDays}`} />
        </Route>
        <Route path={['/reports/nutrition', '/reports/nutrition/']} exact>
          <Redirect to={`/reports/nutrition/${demoDays}`} />
        </Route>
        <Route path={['/reports/exercise', '/reports/exercise/']} exact>
          <Redirect to={`/reports/exercise/${demoDays}`} />
        </Route>
        <Route path={['/reports/day', '/reports/day/']} exact>
          <Redirect to={`/reports/day/${demoDays.substring(0, demoDays.indexOf('_'))}`} />
        </Route>
        <Route path={['/reports/diary', '/reports/diary/']} exact>
          <Redirect to={`/reports/diary/${demoDays}`} />
        </Route>
        <Route path={['/reports/cycles', '/reports/cycles/']} exact>
          <Redirect to={`/reports/cycles/${demoDays}`} />
        </Route>

        <Route path="/reports/" exact>
          <Redirect to="/#reports" />
        </Route>
        {standalone
          ? (
            <Redirect to={`/reports/agp/${demoDays}`} />
          )
          : (
            <Route path="/">
              <Homepage store={mockStore} t={t}/>
            </Route>
          )
        }
      </Switch>
      {standalone
        ? undefined
        : <Footer />
      }
    </ErrorBoundary>
  );
}

export default LandingPageRoute;
